<script>
  import { onMount } from "svelte";
  import CustomerApi from "@thetechdept/shopify-bones-customer-api";
  export let customerId;
  export let customerIdSignature;
  export let proxy;
  let state = "loading";
  let wishlist;
  let error = null;

  // Create API instance
  const customerApi = new CustomerApi({
    customerType: "customer", // moot
    customerId,
    customerIdSignature,
    proxy,
  });

  onMount(async () => {
    customerApi
      .getWishlist()
      .then((f) => {
        console.log("Wishlist", f);
        wishlist = f;
        state = "loaded";
        setTimeout(() => {
          // Bang init to any shopify-bones-add-to-cart
          window.initSvelteAddToCarts && window.initSvelteAddToCarts();
        }, 100); // JIC
      })
      .catch((e) => {
        error = `Could not get wishlist: ${e.message}`;
        state = "erroring";
      });
  });

  const deleteClick = (id) => (e) => {
    e.preventDefault();
    state = "deleting";
    // Errors that surely won't happen, but JIC
    if (!wishlist.length) {
      error = "You have no wishlist within which to delete";
      state = "erroring";
      return console.error(error);
    }
    if (!id) {
      error = "Chosen product has no variant ID";
      state = "erroring";
      return console.error(error);
    }
    // Filter out the offending item
    wishlist = wishlist.filter((f) => f.id != id);
    // Reduce to just their variant IDs
    const wishlistIds = wishlist.map((f) => f.id);
    customerApi
      .update({
        name: "wishlist",
        value: wishlistIds,
      })
      .then((data) => {
        console.log("Wishlist deleted", id);
        state = null;
      })
      .catch((e) => {
        console.error("Wishlist update error", e);
        state = "erroring";
      });
  };
</script>

<div class="wishlist">
  {#if error}
    <div class="alert alert-danger">{error}</div>
  {:else if state === "loading"}
    <div class="loading" />
  {:else if !wishlist || !wishlist.length}
    <div class="alert alert-info">You have no wishlist yet.</div>
  {:else}
    <table
      class="table table-responsive {state === 'deleting' ? '-deleting' : ''}"
    >
      <tr>
        <th />
        <th>Title</th>
        <th>Price</th>
        <th />
      </tr>
      {#each wishlist as f}
        <tr class="table__product">
          <td data-th="Image">
            <a href={f.productLink}>
              <div>
                <img src={f.productImg} alt="" />
              </div>
            </a>
          </td>
          <td data-th="Title">
            <a href={f.productLink}>{f.name}</a>
          </td>
          <td data-th="Price">£{f.price}</td>
          <td data-th="">
            <!-- <a href={f.productLink} role="button" class="-small">View</a> -->
            {#if window.initSvelteAddToCarts}
              <div
                class="svelte-add-to-cart"
                data-id={f.id}
                data-image={f.productImg}
                data-max={f.inventoryQuantity}
              />
            {:else}
              <form action="/cart/add" class="add-to-cart" method="post">
                <input type="hidden" name="id" value={f.id} />
                <button type="submit" class="button" id="AddToCart{f.id}">
                  Add to Cart
                </button>
              </form>
            {/if}
            <!-- {#if customerType == 'practitioner'}
              <button
                style="display:none"
                class="button add-to-protocol"
                data-product-id={f.id || ''}
                data-product-url={f.productLink || ''}
                data-product-title={f.name || ''}
                data-product-image={f.productImg || ''}>
                Add to Protocol
              </button>
            {/if} -->
            <button class="button -delete" on:click={deleteClick(f.id)}>
              Delete
            </button>
          </td>
        </tr>
      {/each}
    </table>
  {/if}
</div>
